export const deClientPortalHandoverApprovalSection = {
    title: 'Teilen & Freigeben',
    olderDraftTooltip: 'Es liegt ein aktuellerer Entwurf vor. Wechseln Sie zum neuesten Entwurf.',
    handoverInfoText: 'Ihr Gutachter/Ihre Gutachterin hat Ihre Anmerkungen erhalten und wird einen neuen Entwurf zur Verfügung stellen.',
    internalApproval: {
        openApprovalDescription: 'Freigabe durch Fondspartner erteilen.',
        approvedInfoText: 'Die finale Freigabe durch die KVG steht noch aus.',
        sectionLabel: 'Freigabe durch Fonds',
    },
    approval: {
        sectionLabel: 'Freigabe durch KVG',
        approvedInfoText:
            'Ihr Gutachter/Ihre Gutachterin hat Ihre Freigabe zur Finalisierung erhalten und wird das finale Gutachten zur Verfügung stellen.',
    },
}
